import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CacheService, IQuestionBO, IQuestionnaireBO, IQuestionnaireQuestionBO, ITypeQuestionnaireBO } from '@mapfre-tech/amap3';
import { mapQuestion } from '../question/question.service';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  className = 'SurveyService';

  constructor(private http: HttpClient, private translateService: TranslateService, private cacheService: CacheService) {
  }

  getAllSurveys(): Observable<IQuestionnaireBO[]> {
    return this.http.get<IQuestionnaireBO[]>(environment.base_URL + "/questionnaires")
  }

  getSurveyByID(id: number): Observable<IQuestionnaireBO> {
    return this.getAllSurveys().pipe(map<IQuestionnaireBO[], IQuestionnaireBO>((res: any) => _.find(res, ['ID', id])));
  }

  getQuestionsSurvey(id: number): Observable<IQuestionnaireQuestionBO[]> {
    return this.http.get<IQuestionnaireQuestionBO[]>(environment.base_URL + `/questionnaires/${id}/questions`).pipe(map((res) => {
      return res.map(question => mapQuestion(question as IQuestionBO, this.translateService)) as IQuestionnaireQuestionBO[];
    }))
  }

  updateQuestionsSurvey(questions: IQuestionnaireQuestionBO[], id: number) {
    return this.http.put(environment.base_URL + `/questionnaires/version/${id}`, questions);
  }

  newSurvey(newSurvey: IQuestionnaireBO) {
    return this.http.post(environment.base_URL + "/questionnaires", newSurvey);
  }

  updateSurvey(editedSurvey: IQuestionnaireBO, id: number) {
    return this.http.put(environment.base_URL + `/questionnaires/${id}`, editedSurvey)
  }

  getSurveyTypes(cache = true, cacheKey = "surveyTypes"): Observable<ITypeQuestionnaireBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeQuestionnaireBO[]>;
    } else {
      const observable = this.http.get<ITypeQuestionnaireBO[]>(environment.base_URL + "/types-questionnaire").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

}
